const Title = (props) => (
  <div
    className={`col-12 ${
      props.align !== undefined ? "text-" + props.align : ""
    } p-3 display-4 text-muted mb-3 ${
      props.animation !== undefined ? props.animation : ""
    }`}
  >
    {props.children}
  </div>
);

export default Title;
